import {
  IMPORT_DATA_PATH,
  IMPORTING_HRIS_DATA_PATH,
  ADD_ESTABLISHMENT_DETAILS_PATH,
  JOB_CATEGORY_CONFIRMATION_PATH,
  REVIEW_DATA_PATH,
  PREVIEW_REPORT_PATH,
  DOWNLOAD_REPORT_PATH
} from 'constants/paths';

export const DATA_IMPORT_STEP = 'dataImport';
export const REVIEW_DATA_STEP = 'reviewData';
export const IMPORTING_HRIS_DATA_STEP = 'importingHRISData';
export const ADD_ESTABLISHMENT_DETAILS_STEP = 'addEstablishments';
export const JOB_CATEGORY_CONFIRMATION_STEP = 'jobCategoryConfirmation';
export const PREVIEW_REPORT_STEP = 'previewReport';
export const DOWNLOAD_REPORT_STEP = 'downloadReport';

export const REPORT_STEPS_MAPPING: { [key: string]: string | null } = {
  [DATA_IMPORT_STEP]: IMPORT_DATA_PATH,
  [IMPORTING_HRIS_DATA_STEP]: IMPORTING_HRIS_DATA_PATH,
  [REVIEW_DATA_STEP]: REVIEW_DATA_PATH,
  [ADD_ESTABLISHMENT_DETAILS_STEP]: ADD_ESTABLISHMENT_DETAILS_PATH,
  [JOB_CATEGORY_CONFIRMATION_STEP]: JOB_CATEGORY_CONFIRMATION_PATH,
  [PREVIEW_REPORT_STEP]: PREVIEW_REPORT_PATH,
  [DOWNLOAD_REPORT_STEP]: DOWNLOAD_REPORT_PATH
};

export const REPORT_STEPS = [
  DATA_IMPORT_STEP,
  REVIEW_DATA_STEP,
  ADD_ESTABLISHMENT_DETAILS_STEP,
  JOB_CATEGORY_CONFIRMATION_STEP,
  PREVIEW_REPORT_STEP,
  DOWNLOAD_REPORT_STEP
];

export const PAID_REPORT_STEPS = [
  DATA_IMPORT_STEP,
  REVIEW_DATA_STEP,
  ADD_ESTABLISHMENT_DETAILS_STEP,
  JOB_CATEGORY_CONFIRMATION_STEP,
  DOWNLOAD_REPORT_STEP
];

export const DATA_IMPORT_STEPS_MAPPING: { [key: string]: number } = {
  [REVIEW_DATA_STEP]: 2,
  [ADD_ESTABLISHMENT_DETAILS_STEP]: 3,
  [JOB_CATEGORY_CONFIRMATION_STEP]: 4
};
export const NUMBER_OF_DATA_IMPORT_STEP = 4;
